import { tv } from 'tailwind-variants';

const styles = tv({
    base: `
  iris:grid 
  iris:gap-(--base-space-px-24) 
  iris:md:gap-(--base-space-px-12)
  `,
});

export { styles as default };
